import { z } from 'zod';

/** Como a carteira pode ser usada (`paymentMethods` do `ExpensesUserWallet`). */
export const VollWalletPaymentMethodSchema = z.enum(['PIX', 'REFUND', 'CREDIT_CARD']);

/**
 * Uma carteira de despesas como a folha da wallet a desenha: o recorte do
 * `ExpensesUserWallet` (wallets-api) que o BFF entrega em `GET /voll-wallet/wallets`.
 * `blocked` com `pendingInvoice` é a carteira travada por nota fiscal pendente.
 */
export const VollWalletSchema = z
  .object({
    id: z.string().min(1),
    name: z.string(),
    available: z.number(),
    used: z.number(),
    total: z.number(),
    /** ISO 4217; ausente = real. */
    currency: z.string().length(3).optional(),
    /** Último dia em que o saldo vale; ausente = sem validade. */
    validUntil: z.iso.date().optional(),
    invoiceRequired: z.boolean(),
    pendingInvoice: z.boolean(),
    blocked: z.boolean(),
    paymentMethods: z.array(VollWalletPaymentMethodSchema),
    /** A política aceita reembolso acima do saldo (`allowsRefundWithoutBalance`); ausente = não
     *  (BFF anterior ao campo). */
    refundWithoutBalance: z.boolean().optional(),
  })
  .strict();
export type VollWallet = z.infer<typeof VollWalletSchema>;

export const VollWalletListResponseSchema = z
  .object({ wallets: z.array(VollWalletSchema) })
  .strict();
